import { render, staticRenderFns } from "./CertificateVerificationDialog.vue?vue&type=template&id=631a3702"
import script from "./CertificateVerificationDialog.vue?vue&type=script&lang=js"
export * from "./CertificateVerificationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports